// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgTrees = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    viewBox="0 0 20 20"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3.5a3.5 3.5 0 0 0-.75 6.92V7.75a.75.75 0 0 1 1.5 0v2.67A3.501 3.501 0 0 0 13 3.5ZM8 7a5.001 5.001 0 0 0 4.25 4.944V16.5h-6.5v-2.595a3.001 3.001 0 1 0-1.5 0V16.5h-1.5a.75.75 0 0 0 0 1.5H17.25a.75.75 0 0 0 0-1.5h-3.5v-4.556A5.001 5.001 0 0 0 13 2a5 5 0 0 0-5 5ZM5 9.5a1.5 1.5 0 0 0-.75 2.8v-.55a.75.75 0 0 1 1.5 0v.55A1.5 1.5 0 0 0 5 9.5Z"
    />
  </svg>
)

export default SvgTrees
